module.exports = __webpack_public_path__ + "teqbahn-assets/media/4.593b57a8.pdf";